import React, { useCallback } from 'react'
import { Separator } from '../separator'
import { Radio } from '../form'
import { MandatoryText } from './../text/mandatory-text';
import { Properties } from '../../models/polymer/Properties.model';


interface AddressSelectionProps extends React.HtmlHTMLAttributes<HTMLDivElement>{
  onItemSelect?: (value:Properties) => void;
  value?: Properties;
  required?: boolean;
  header?:string[];
  items?:Properties[];
}

function AddressSelection({items=[], required=true,...props}:AddressSelectionProps) {
  const handleSelection = useCallback((item: Properties) => () => {
    props?.onItemSelect?.(item);
  },[]);
  return (
    <div style={{...props.style}}>
      <div className='polymer-address-selection'>
        <div className='polymer-address-selection__header-section' style={{ display: "flex", flexDirection: "row" }}>
          {props.header?.map((header_title,_index:number)=>{
            return (
              <div style={{ flex: 1 }} key={`${header_title}`} className={`${_index === 0 ? "polymer-address-selection__header-section-first": ""}`}>
                <p className='m-0' style={{paddingLeft:_index === 0 ?'39px' : undefined}}>{header_title}</p>
              </div>
            )
          })}
        </div>
        {
          items?.map((item,_index:number)=>{
            const key = _index;
            return (
              <div key={key}>
                <Separator style={{ margin: "16px 0" }} />
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <div className='polymer-address-selection__content-address' style={{ flex: 1 }}>
                    <div className='polymer-address-selection__content-address-div'>
                      <Radio isActive={JSON.stringify(props.value) === JSON.stringify(item)} onClick={handleSelection(item)} description={<p className='m-0'>{item.address}</p>} />
                    </div>
                  </div>
                  <div className='polymer-address-selection__content-role' style={{ flex: 1 }}>
                    {item.owners.map(e=>{
                      const role = !!e.role_name ? `(${e.role_name})` : "";
                      return <p key={e.name} className='m-0 owner_name'>{`${e.name} ${role}`}</p>
                    })}
                    {item.owners.length === 0 && item.additional_roles.map(e=>{
                      const role = !!e.role_name ? `(${e.role_name})` : "";
                      return <p key={e.name} className='m-0 owner_name'>{`${e.name} ${role}`}</p>
                    })}
                  </div>
                </div>
              </div>
            )
          })
        }
      </div>
      {required && <div style={{marginTop:"16px"}}><MandatoryText/></div>}
    </div>
  )
}

export default AddressSelection